import { render, staticRenderFns } from "./live-overview.vue?vue&type=template&id=20059917&scoped=true"
import script from "./live-overview.vue?vue&type=script&lang=js"
export * from "./live-overview.vue?vue&type=script&lang=js"
import style0 from "./live-overview.vue?vue&type=style&index=0&id=20059917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20059917",
  null
  
)

export default component.exports